<template>
  <div @click="createNewTeam">
    <div
      class="create-new-team-item"
    >
      <div
        class="button"
        @mouseover="onHoverCreatNewTeam"
        @mouseleave="onMouseLeaveCreateNewTeam"
      >
        <font-awesome-icon icon="plus" size="sm" />
      </div>
      <div class="aha-tooltip-customize" v-if="showCreateTeamTooltip">
        Create a team
      </div>
      <div
        v-if="showCreateTeamTooltip"
        class="aha-tooltip-customize--tooltip__tip"
      ></div>
    </div>
    <ModalCreateNewTeam
      v-if="showCreateTeamModal"
      @hide="hideCreatTeamModal"
    />
    <ModalCreateNewTeamNotReady
      v-if="showCreateTeamRefuseModal"
      @hide="hideCreatTeamRefuseModal"
    />
  </div>
</template>
<script>
import ModalCreateNewTeam from '@/components-v2/modals/CreatNewTeam.vue'
import ModalCreateNewTeamNotReady from '@/components-v2/modals/CreateNewTeamNotReady.vue'
import Utils from '@/util'
import constants from '@/constant'

export default {
  components: {
    ModalCreateNewTeam,
    ModalCreateNewTeamNotReady,
  },
  data() {
    return {
      showCreateTeamTooltip: false,
      showCreateTeamModal: false,
      showCreateTeamRefuseModal: false,
    }
  },
  methods: {
    onHoverCreatNewTeam() {
      this.showCreateTeamTooltip = true
    },
    onMouseLeaveCreateNewTeam() {
      this.showCreateTeamTooltip = false
    },
    createNewTeam() {
      if (this.$store.state.currentAccount.id) this.showCreateTeamRefuseModal = true
      else this.showCreateTeamModal = true
      const hasTeam = !!this.$store.state.currentAccount.id
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_APP, 'SideNav > Create a team', '', '', {
        plan: this.$store.state.currentUser.plan,
        hasTeam,
      })
    },
    hideCreatTeamModal() {
      this.showCreateTeamModal = false
    },
    hideCreatTeamRefuseModal() {
      this.showCreateTeamRefuseModal = false
    },
  },
}
</script>
<style lang='scss'>
.create-new-team-item {
  @apply flex justify-center items-center cursor-pointer;
  .button {
    @apply flex justify-center items-center;
    position: relative;
    background: #3F4557;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    transition: background 0.5s linear;
    &:hover {
      transition: background 0.5s linear;
      background: #525F7F;
    }
  }
}
.aha-tooltip-customize {
  @apply hidden sm:block;
  position: fixed;
  max-width: 20rem;
  max-height: 5rem;
  padding: 0.25rem;
  left: 3.25rem;
  background: white;
  border-radius: 0.25rem;
  color: black;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aha-tooltip-customize--tooltip__tip {
  @apply hidden sm:block;
  z-index: 1;
  position: absolute;
  left: 3.25rem;
  width: 6px;
  height: 6px;
  background: #FFFFFF;
  transform: translate(-50%, 0) rotate(45deg);
  border-bottom-right-radius: 2px;
  outline: none;
}
</style>
